import { type AdData, ConfigName } from '../../types';
import { useAdDataContext } from '../../useAdDataContext';
import { GlobalContext } from '../GlobalDataProvider';
import type { GlobalConfig } from '../types';

export function useGlobalConfig(): AdData<GlobalConfig> {
  return useAdDataContext(ConfigName.GLOBAL, GlobalContext);
}
